import React, { useState } from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    VStack,
    Switch,
} from '@chakra-ui/react';

interface BusFormProps {
    onSubmit: (data: any) => void;
    initialData?: any;
}

const BusForm: React.FC<BusFormProps> = ({ onSubmit, initialData }) => {
    const safeData = initialData || {};

    const [formData, setFormData] = useState({
        company: safeData.company || '',
        busNumber: safeData.busNumber || '',
        from: safeData.from || '',
        fromDeport: safeData.fromDeport || '',
        to: safeData.to || '',
        toDeport: safeData.fromDeport || '',
        departureDate: safeData.departureDate || '',
        arrivalDate: safeData.departureDate || '',
        price: safeData.price || 0,
        availability: safeData.availability ?? true,
        seatsAvailable: safeData.seatsAvailable || 0,
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = e.target;
        const checked = (e.target as HTMLInputElement).checked;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
                <FormControl isRequired>
                    <FormLabel>Company</FormLabel>
                    <Input name="company" value={formData.company} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel>Bus Number</FormLabel>
                    <Input name="busNumber" value={formData.busNumber} onChange={handleChange} />
                </FormControl>

                <FormControl isRequired>
                    <FormLabel>From</FormLabel>
                    <Input name="from" value={formData.from} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel>From Deport</FormLabel>
                    <Input name="fromDeport" value={formData.fromDeport} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel>To</FormLabel>
                    <Input name="to" value={formData.to} onChange={handleChange} />
                </FormControl>

                <FormControl isRequired>
                    <FormLabel>Departure Date</FormLabel>
                    <Input type="datetime-local" name="departureDate" value={formData.departureDate} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel>Seats Available</FormLabel>
                    <Input type="number" name="seatsAvailable" value={formData.seatsAvailable} onChange={handleChange} />
                </FormControl>

                <FormControl isRequired>
                    <FormLabel>Price</FormLabel>
                    <Input type="number" name="price" value={formData.price} onChange={handleChange} />
                </FormControl>

                <FormControl display="flex" alignItems="center">
                    <FormLabel htmlFor="availability" mb="0">
                        Available
                    </FormLabel>
                    <Switch
                        id="availability"
                        name="availability"
                        isChecked={formData.availability}
                        onChange={handleChange}
                    />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel>Final Deport</FormLabel>
                    <Input name="toDeport" value={formData.toDeport} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel>Arrival</FormLabel>
                    <Input type="datetime-local" name="arrivalDate" value={formData.arrivalDate} onChange={handleChange} />
                </FormControl>

                <Button colorScheme="teal" type="submit">
                    Submit
                </Button>
            </VStack>
        </form>
    );
};

export default BusForm;
